import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UnsubscribeMutation,
  UnsubscribeMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const unsubscribeMutation = graphql(`
  mutation unsubscribe($input: UnsubscribeRequest!) {
    unsubscribe(UnsubscribeRequest: $input)
  }
`);

export function useLeadSubscriptionUnsubscribe(
  options?: UseMutationOptions<UnsubscribeMutation, unknown, UnsubscribeMutationVariables, unknown>,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(unsubscribeMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      // Refetch the status so the page reflects the now-inactive subscription.
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptionStatus"] });
      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });
}
